import { render, staticRenderFns } from "./MemberChangeTeamModal.vue?vue&type=template&id=6ef9d144&"
import script from "./MemberChangeTeamModal.vue?vue&type=script&lang=js&"
export * from "./MemberChangeTeamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports